import { t } from "i18next"
import { Number } from "components/common"
import { useMemo } from "react"
import { IconText } from "components/custom"
import { List } from "antd"
import cx from "clsx"
import styles from "../index.module.less"
import { localisedValue } from "utils"
import getAgencyConfigurations from "utils/agencyConfigurations"

const InvoiceSummary = ({ invoice }) => {
  const agency = getAgencyConfigurations()
  const invoiceSummary = useMemo(() => {
    return [
      [
        t("Created At"),
        (invoice?.date &&
          new Date(invoice?.date).toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" })) ||
          "-",
      ],
      [
        t("Due Date"),
        (invoice?.dueDate &&
          new Date(invoice?.dueDate).toLocaleDateString("en-US", {
            month: "short",
            day: "2-digit",
            year: "numeric",
          })) ||
          "-",
      ],
      [t("Sub Total"), <Number value={invoice?.subTotal} isCurrency={true} compact="" digitAfterFraction={2} />],
      [t("Tax"), <Number value={invoice?.taxAmount} isCurrency={true} compact="" digitAfterFraction={2} />],
      ...(invoice?.billingTypeKey === "medallion"
        ? [
            [
              t("Medallion Share"),
              <Number value={invoice?.medallionShare} isCurrency={true} compact="" digitAfterFraction={2} />,
            ],
          ]
        : []),
      [
        t("Adjustment"),
        <Number value={invoice?.adjustmentAmount} isCurrency={true} compact="" digitAfterFraction={2} />,
      ],
      ...(invoice?.billingTypeKey === "tripartite"
        ? [
            [
              `${localisedValue({ object: agency?.Platform, key: "platformTitle" }) || "-"} ${t("Core Fee")}`,
              <Number value={invoice?.zameenCore?.total} isCurrency={true} compact="" digitAfterFraction={2} />,
            ],
            [
              `${localisedValue({ object: agency?.Platform, key: "platformTitle" }) || "-"} ${t("Media Fee")}`,
              <Number value={invoice?.zameenMedia?.total} isCurrency={true} compact="" digitAfterFraction={2} />,
            ],
          ]
        : []),
      [
        t("Total"),
        invoice?.total && <Number value={invoice?.total} isCurrency={true} compact="" digitAfterFraction={2} />,
      ],
    ]
  }, [invoice])
  return (
    <div className="pb-12" style={{minHeight: 170}}>
      <IconText
        title={t("Invoice Summary")}
        icon={"BsFileEarmarkText"}
        iconProps={{ style: { color: "#9D9D9D" }, hasBackground: true, size: "1em" }}
        gap={8}
        style={{ fontWeight: 600 }}
        className="mbe-12"
      />

      <List size="small" className={cx(styles.listingMain)}>
        {invoiceSummary?.map(e => (
          <List.Item>
            <div className="gray-700">{e[0]}</div>
            <div>{e[1]}</div>
          </List.Item>
        ))}
      </List>
    </div>
  )
}
export default InvoiceSummary
